import { ConstantProperty, } from "cesium";
import { getDefaultPointToPointPMISettings } from "../settings/earthbrain-site-settings";
import { EarthBrainUtils } from "../utilities/earthbrainutility";
export class LinearMeasurement {
    _crossSectionPolylineEntity;
    _outline = [];
    _start;
    _end;
    _site;
    _viewer;
    constructor(start, end, site, viewer) {
        this._start = start;
        this._end = end;
        this._site = site;
        this._viewer = viewer;
        this._crossSectionPolylineEntity = EarthBrainUtils.createLineEntity(this._viewer, "outline", [], getDefaultPointToPointPMISettings());
    }
    async update(start, end) {
        const pointsArrayWorldSpace = [start, end];
        const localPointsArray = await this._site.convertPointsToLocalSpace(pointsArrayWorldSpace); //.associatePointCloud.transformPointsToLocalSpace(pointsArrayWorldSpace);
        const interpolatedPoints = EarthBrainUtils.getLinearInterpolation(localPointsArray[0], localPointsArray[1], 0.5, true, true);
        const outlines = [];
        // calculating heightmap for all roads/flats/designs/pointclouds
        // outlines.push(
        // 	associatePointCloud.heightMap.tracePoints(
        // 		interpolatedPoints,
        // 	),
        // );
        for (const p of this._site.getPointClouds()) {
            if (p.tileSet.show) {
                outlines.push(p.tracePoints(interpolatedPoints));
            }
        }
        for (const d of this._site.getDesignDatas()) {
            if (d.tileSet.show) {
                // Calculating outline points in designs reference
                // const localPointsArrayForDesign = d.transformPointsToLocalSpace(pointsArrayWorldSpace);
                const refDesignPoints = EarthBrainUtils.getLinearInterpolation(localPointsArray[0], localPointsArray[1], 0.5, true, true);
                const pointsLocalDesign = d.tracePoints(refDesignPoints);
                const pointLocalPointCloud = await this._site.convertPointsToWGS84(pointsLocalDesign);
                // const pointLocalPointCloud = pointsLocalDesign.map(p => p
                //     ? associatePointCloud.transformPointToLocalSpace(d.transformPointToWorldSpace(p))
                //     : undefined
                // );
                outlines.push(pointLocalPointCloud);
            }
        }
        this._site
            .getRoads()
            .forEach((road) => road.isVisible() &&
            outlines.push(road.tracePoints(interpolatedPoints)));
        this._site
            .getFlatGrounds()
            .forEach((flat) => flat.isVisible() &&
            outlines.push(flat.tracePoints(interpolatedPoints)));
        this._site
            .getReferenceTopologies()
            .forEach((refTopo) => refTopo.getDrawing2DImage().isVisible() &&
            outlines.push(refTopo.tracePoints(interpolatedPoints)));
        // Create 3D Local and 2D outline for measurement
        let finalOutlineLocal3D = [];
        outlines.forEach((outlineUnderProcess) => {
            for (let i = 0; i < outlineUnderProcess.length; ++i) {
                const point = outlineUnderProcess[i];
                if (point &&
                    (!finalOutlineLocal3D[i] || point.z > finalOutlineLocal3D[i].z)) {
                    finalOutlineLocal3D[i] = point;
                }
                else if (!point && !finalOutlineLocal3D[i]) {
                    finalOutlineLocal3D[i] = undefined;
                }
            }
        });
        finalOutlineLocal3D = finalOutlineLocal3D.filter((f) => f !== undefined);
        this._outline = await this._site.convertPointsToWGS84(finalOutlineLocal3D); // associatePointCloud.transformPointsToWorldSpace(finalOutlineLocal3D);
        this._crossSectionPolylineEntity.polyline.positions = new ConstantProperty(this._outline);
    }
    updateVisibility(val) {
        this._crossSectionPolylineEntity.show = val;
    }
    getData() {
        return this._outline;
    }
    dispose() {
        this._viewer.entities.remove(this._crossSectionPolylineEntity);
        this._crossSectionPolylineEntity = undefined;
    }
    zoomTo() {
        this._viewer.zoomTo(this._crossSectionPolylineEntity);
    }
    async recalculate() {
        await this.update(this._start, this._end);
        return;
    }
}
//# sourceMappingURL=linear-measurement.js.map